import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import ResourceServiceTagForm from '../containers/ResourceServiceTagFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class ResourceServiceTagAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `ResourceServiceTagAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('resource_service_tag_route_add')} />
          <ResourceServiceTagForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default ResourceServiceTagAddScreen;

Logger.log('silly', `ResourceServiceTagAddScreen loaded.`);
